'use client';

import PageTab from '@pc/components/molecules/tab/PageTab';
import PageTabsContainer from '@pc/components/molecules/tab/PageTabsContainer';
import { useRouter } from 'next/navigation';

function PolicyTabs() {
  const router = useRouter();
  return (
    <div>
      <PageTabsContainer
        className='h-[unset] w-full max-w-[1440px]'
        contentClassName='flex justify-start w-full max-w-[1440px]'
      >
        <PageTab includedURLPath='/policy/privacy' onClick={() => router.push('/policy/privacy')}>
          개인정보처리방침
        </PageTab>
        <PageTab includedURLPath='/policy/service' onClick={() => router.push('/policy/service')}>
          이용약관
        </PageTab>
        <PageTab includedURLPath='/policy/youth' onClick={() => router.push('/policy/youth')}>
          청소년보호정책
        </PageTab>
        <PageTab includedURLPath='/policy/play' onClick={() => router.push('/policy/play')}>
          시청기준안내
        </PageTab>
        <PageTab includedURLPath='/policy/cast' onClick={() => router.push('/policy/cast')}>
          방송기준안내
        </PageTab>
        <PageTab includedURLPath='/policy/rights' onClick={() => router.push('/policy/rights/intro')}>
          권리침해신고센터
        </PageTab>
      </PageTabsContainer>
    </div>
  );
}

export default PolicyTabs;
